<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="''"></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList.length > 0" class="banner_box">
				<div v-if="bannerList.length > 1" class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick(1)">
					<img src="../../assets/img/icon_left.webp" />
				</div>
				<div v-if="bannerList.length > 1" class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick(1)">
					<img src="../../assets/img/icon_right.webp" />
				</div>
				<van-swipe class="" :autoplay="5000" indicator-color="#808080" ref="swipeOne" :stop-propagation="false" @change="bannerChange">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div
							class="banner_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div v-if="isRload" class="msg_box">
								<div class="left">
									<div class="left_msg">
										<div class="tit"
											data-aos="fade-left"
											data-aos-duration="400"
											data-aos-delay="100"
											data-aos-offset="0"
											data-aos-once="true"
										>{{ value.title }}</div>
										<div class="txt"
											data-aos="fade-left"
											data-aos-duration="400"
											data-aos-delay="200"
											data-aos-offset="0"
											data-aos-once="true"
										>{{ value.miaoshu }}</div>
										<div v-if="value.url != '/' && value.url != ''" class="btn_box"
											data-aos="fade-in"
											data-aos-duration="400"
											data-aos-delay="500"
											data-aos-offset="0"
											data-aos-once="true"
										>
											<van-button color="#E37542" class="btn_el" @click="goBanner(value)">LEARN MORE</van-button>
										</div>
									</div>
								</div>
								<div class="right"></div>
							</div>
							<img :src="weburl+ value.image" style="min-height: 380px;" />
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
			<!--banner-->
			<!--Search-->
			<div class="search_box">
				<div class="search_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">SEARCH PRODUCTS</div>
					<input v-model="inputVal" class="input_el" placeholder="Search by Name, or Keyword" @keyup.enter="goProducts('search')" />
					<van-icon name="search" class="icon" size="30" color="#ffffff" @click="goProducts('search')" />
				</div>
			</div>
			<!--Search-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div style="width: 100%;max-width: 1920px;margin: 0 auto;overflow: hidden;">
						<img class="bg" src="../../assets/img/index/block_1.webp" />
					</div>
					<div class="msg_box">
						<div class="msg_box_el" style="padding-right: 100px;">
							<div class="tit"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>Antibodies</div>
							<div class="txt"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="200"
								data-aos-offset="0"
								data-aos-once="true"
							>
								Our extensive portfolio includes hybridoma or<br />recombinant monoclonal and polyclonal antibodies for<br />immunological applications
							</div>
							<div class="btn_box" style="color: #E37542;" @click="goProducts(productType[0].id)"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="500"
								data-aos-offset="0"
								data-aos-once="true"
							>
								Explore Antibodies&nbsp;<van-icon name="down" class="icon" size="17" color="#E37542" />
							</div>
						</div>
						<div class="msg_box_el" style="padding-left: 100px;">
							<div class="tit"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>Antigens</div>
							<div class="txt"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="200"
								data-aos-offset="0"
								data-aos-once="true"
							>
								The reliable antigen reagents are specifically crafted to<br />meet the demands of a variety of assay technologies
							</div>
							<div class="btn_box" style="color: #006BB3;" @click="goProducts(productType[1].id)"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="500"
								data-aos-offset="0"
								data-aos-once="true"
							>
								Explore Antigens&nbsp;<van-icon name="down" class="icon" size="17" color="#006BB3" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/img/index/block_2.webp" />
					</div>
					<div class="right">
						<div class="tit"
							data-aos="fade-left"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>UC reagent i-Membrane</div>
						<div class="txt"
							data-aos="fade-left"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							i-Membrane is an industry leading partner to diagnostic<br />
							manufacturers worldwide. We ensure a reliable supply of<br />
							components and customizable services including membrane card<br />
							development for IVD rapid testing applications.
						</div>
						<div class="btn_box" @click="goIm"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<van-button color="#E37542" class="btn_el">LEARN MORE</van-button>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div v-if="false" class="block_3">
				<div class="block_3_main">
					<div class="title">Devices ZONE</div>
					<div class="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.</div>
					<div class="block_banner">
						<div v-if="deviceIndex != 0" class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick(2)">
							<img src="../../assets/img/icon_left.webp" />
						</div>
						<div v-if="deviceIndex != 2" class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick(2)">
							<img src="../../assets/img/icon_right.webp" />
						</div>
						<van-swipe
							class=""
							:loop="false"
							:autoplay="0"
							indicator-color="white"
							ref="swipeTwo"
							:stop-propagation="false"
							:show-indicators="false"
							:width="390"
							@change="onDeviceChange"
						>
							<van-swipe-item v-for="(value, index) in devicesList" :key="index">
								<div class="block_banner_el">
									<img v-if="value.imgUrl" class="img_el" :src="value.imgUrl" />
									<div class="tit">{{ value.title }}</div>
									<div class="txt">{{ value.desc }}</div>
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div v-if="false" class="block_4">
				<div class="block_4_main">
					<div class="left">
						<div class="tit"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>CLIA Lab Testing</div>
						<div class="txt"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							Jtests Clinical Laboratory specializing in RT-PCR-<br />
							based tests. Alongside, we offer comprehensive<br />
							blood and urinary analysis, prioritizing molecular<br />
							diagnostics.
						</div>
						<div class="btn_box" @click="goServices"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							Explore&nbsp;&nbsp;<van-icon name="down" class="icon" size="18" color="#E37542" />
						</div>
					</div>
					<div class="right"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el" @click="goServices">
							<div class="img_box">
								<img src="../../assets/img/index/block_3.webp" />
							</div>
							<div class="tit">
								Rapid Test Services
							</div>
						</div>
						<div class="list_el" @click="goServices">
							<div class="img_box">
								<img src="../../assets/img/index/block_4.webp" />
							</div>
							<div class="tit">
								Urinary Analysis for Infectious Diseases
							</div>
						</div>
						<div class="list_el" @click="goServices">
							<div class="img_box">
								<img src="../../assets/img/index/block_5.webp" />
							</div>
							<div class="tit">
								Blood Routine Testing
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">News & Events</div>
					<div class="btn_box" @click="goNews">
						<van-button color="#E37542" class="btn_el">ALL</van-button>
					</div>
					<div v-if="newsList.length > 0" class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-for="(value, index) in newsList" :key="index" class="list_el" @click="goNewsInfo(value)">
							<div class="img_box">
								<van-image class="img_el" width="348px" height="232px" :src="weburl + value.image" fit="cover" />
							</div>
							<div class="tit">{{ value.title }}</div>
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { UPURL } from '@/util/util.js';
import { bannerList } from '@/api/public';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			devicesList: [],
			deviceIndex: 0,
			productType: [],
			inputVal: '',
			newsList: [],
			weburl: '',
			bannerList: [],
			isRload: true,
		}
	},
	created(){
		let that = this;
		that.weburl = UPURL;
		if(sessionStorage.getItem('navData')) {
			that.newsList = JSON.parse(sessionStorage.getItem('navData')).news_list;
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
		}
		//轮播图
		bannerList({ leixing: 1 }).then(res => {
			that.bannerList = res.data;
		});
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		bannerChange() {
			let that = this;
			that.isRload = false;
			setTimeout(() => {
				that.isRload = true;
			}, 400);
		},
		goBanner(value) {
			window.location.href = value.url;
		},
		//跳转产品中心
		goProducts(type) {
			let that = this;
			switch(type) {
				case 1:
					that.$router.push({ path: '/products', query: { type: 1 } });
				break;
				case 2:
					that.$router.push({ path: '/products', query: { type: 2 } });
				break;
				case 'search':
					if(that.inputVal) {
						that.$router.push({ path: '/products', query: { search: that.inputVal } });
					}else {
						that.$toast('Please enter name, keywords or catalog number to search.');
					}
				break;
				default:
					that.$router.push({ path: '/products' });
			}
		},
		goNewsInfo(value) {
			let that = this;
			if(value.custom) {
				let routeData = that.$router.resolve({name: "newsInfo", params: { newsId: value.custom } });
				window.open(routeData.href, '_blank');
			}else {
				that.$toast('Parameter exception, unable to obtain detailed information.');
			}
		},
		goNews() {
			this.$router.push({ path: '/news' });
		},
		goServices() {
			let that = this;
			// that.$router.push({ path: '/services' });
		},
		goIm() {
			window.open('https://i-membrane.com/');
		},
		onDeviceChange(index) {
			let that = this;
			that.deviceIndex = index;
		},
		//导航左侧按钮点击
		bannerLeftClick(value) {
			let that = this;
			switch(value) {
				case 1:
					that.$refs.swipeOne.prev();
				break;
				case 2:
					that.$refs.swipeTwo.prev();
				break;
			}
		},
		//导航右侧按钮点击
		bannerRightClick(value) {
			let that = this;
			switch(value) {
				case 1:
					that.$refs.swipeOne.next();
				break;
				case 2:
					that.$refs.swipeTwo.next();
				break;
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	//块5
	.block_5{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		background: url(../../assets/img/index/block_6.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_5_main{
			width: 1140px;
			margin: 0 auto;
			position: relative;
			padding: 58px 0 70px 0;
			.list_box{
				display: flex;
				padding-top: 20px;
				.list_el:last-child{
					margin-right: 0;
				}
				.list_el:hover{
					.img_el{
						transform: scale(1.3);
					}
					.tit{
						color: #E37542;
						font-weight: bold;
					}
				}
				.list_el{
					flex: 1;
					margin-right: 48px;
					cursor: pointer;
					.tit{
						padding-top: 10px;
						font-size: 18px;
						color: #ffffff;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
					}
					.img_box{
						overflow: hidden;
						height: 232px;
						.img_el{
							width: 100%;
							transition: all 0.6s;
						}
					}
				}
			}
			.btn_box{
				position: absolute;
				top: 70px;
				right: 0;
				.btn_el{
					padding: 5px 30px 0 30px;
					font-size: 20px;
					border-radius: 6px;
				}
			}
			.title{
				font-size: 40px;
				font-weight: bold;
				color: #ffffff;
			}
		}
	}
	//块4
	.block_4{
		.block_4_main{
			width: 1140px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			padding: 60px 0;
			.right{
				flex: 1;
				display: flex;
				.list_el:last-child{
					margin-right: 0;
				}
				.list_el:hover{
					.tit{
						color: #E37542;
					}
				}
				.list_el{
					flex: 1;
					margin-right: 24px;
					cursor: pointer;
					.tit{
						padding-top: 24px;
						font-size: 18px;
						text-align: center;
					}
					.img_box{
						overflow: hidden;
						img{
							width: 100%;
						}
					}
				}
			}
			.left{
				width: auto;
				padding-right: 124px;
				.btn_box{
					margin-top: 30px;
					font-size: 18px;
					color: #E37542;
					cursor: pointer;
					user-select: none;
					.icon{
						top: 3px;
						transform: rotate(-90deg);
					}
				}
				.txt{
					padding-top: 5px;
					font-size: 18px;
				}
				.tit{
					font-size: 40px;
					font-weight: bold;
					user-select: none;
				}
			}
		}
	}
	//块3
	.block_3{
		background-color: #F6F6F6;
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			padding: 60px 0 80px 0;
			.block_banner{
				position: relative;
				.block_banner_el{
					height: 490px;
					padding: 25px 25px 0px 25px;
					margin: 30px 40px 0 0;
					background-color: #ffffff;
					border-radius: 6px;
					box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.05);
					.txt{
						margin-top: 10px;
						font-size: 18px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
					}
					.tit{
						margin-top: 20px;
						color: #E37542;
						font-size: 18px;
						font-weight: bold;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
					}
					.img_el{
						width: 100%;
					}
				}
				.icon_left{
					left: -100px;
				}
				.icon_right{
					right: -100px;
				}
			}
			.text{
				font-size: 18px;
				text-align: center;
			}
			.title{
				font-size: 40px;
				font-weight: bold;
				text-align: center;
			}
		}
	}
	//块2
	.block_2{
		.block_2_main{
			display: flex;
			align-items: center;
			width: 1140px;
			margin: 0 auto;
			padding: 80px 0;
			.right{
				flex: 1;
				padding-left: 60px;
				.btn_box{
					margin-top: 36px;
					.btn_el{
						padding: 5px 30px 0 30px;
						font-size: 20px;
						border-radius: 6px;
					}
				}
				.txt{
					padding-top: 5px;
					font-size: 18px;
				}
				.tit{
					font-size: 40px;
					font-weight: bold;
				}
			}
			.left{
				overflow: hidden;
				img:hover{
					transform: scale(1.3);
				}
				img{
					width: 550px;
					transition: all 0.6s;
				}
			}
		}
	}
	//块1
	.block_1{
		.block_1_main:hover{
			img.bg{
				transform: scale(1.3);
			}
		}
		.block_1_main{
			position: relative;
			overflow: hidden;
			text-align: center;
			overflow: hidden;
			.msg_box{
				display: flex;
				align-items: center;
				position: absolute;
				z-index: 1;
				top: 0;
				left: 50%;
				width: 1140px;
				height: 100%;
				transform: translate(-50%, 0);
				.msg_box_el{
					flex: 1;
					text-align: center;
					.btn_box{
						cursor: pointer;
						user-select: none;
						.icon{
							top: 2px;
							transform: rotate(-145deg);
						}
						padding-top: 15px;
					}
					.txt{
						padding-top: 5px;
						font-size: 18px;
					}
					.tit{
						font-size: 40px;
						font-weight: bold;
					}
				}
			}
			img.bg{
				max-width: 1920px;
				width: 100%;
				margin: 0 auto;
				min-width: 1140px;
				transition: all 0.6s;
			}
		}
	}
	//搜索
	.search_box{
		max-width: 1920px;
		width: 100%;
		margin: 0 auto;
		padding: 18px 0 25px 0;
		background-color: #006BB3;
		.search_main{
			width: auto;
			text-align: center;
			.tit{
				font-size: 42px;
				color: #E37542;
			}
			.icon{
				position: relative;
				margin-left: 15px;
				top: 10px;
				cursor: pointer;
				transition: all 0.2s;
			}
			.icon:hover{
				transform: scale(1.2);
			}
			.input_el{
				width: 600px;
				height: 50px;
				padding-top: 6px;
				line-height: 50px;
				text-align: center;
				font-size: 18px;
				color: #006BB3;
				border-radius: 6px;
				border: none;
				background-color: #ffffff;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.banner_el{
			position: relative;
			text-align: center;
			.msg_box{
				position: absolute;
				width: 1140px;
				height: 100%;
				display: flex;
				transform: translate(-50%, 0%);
				left: 50%;
				text-align: left;
				.left{
					flex: 1;
					display: flex;
					align-items: center;
					.left_msg{
						.btn_box{
							margin-top: 36px;
							.btn_el{
								padding: 5px 30px 0 30px;
								font-size: 20px;
								border-radius: 6px;
							}
						}
						.txt{
							font-size: 24px;
							line-height: 30px;
							color: #1A1819;
						}
						.tit{
							font-size: 64px;
							font-weight: bold;
						}
					}
				}
				.right{
					flex: 1;
				}
			}
			img{
				width: 100%;
				max-width: 1920px;
				min-width: 1140px;
			}
		}
		.icon_left{
			left: 50px;
		}
		.icon_right{
			right: 50px;
		}
	}
	.icon_left, .icon_right{
		position: absolute;
		z-index: 1;
		top: 50%;
		margin-top: -25px;
		background: #333333;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		img{
			width: 50px;
			height: 50px;
		}
	}
}
</style>